import fetchLocationsFromCis from './fetchLocationsFromCis'
import getLocationsFromIntl from './getLocationsFromIntl'
import { getUnlocalizedLocations } from './locationMappers'
import type { LocationsFallbackFn, GetLocationsOptions, Iso3166Location } from './types'

export default async function fetchLocations({
  unlocalizedLocations = getUnlocalizedLocations(),
  language,
  fallbackFn = fetchLocationsFromCis,
}: GetLocationsOptions & {
  fallbackFn?: LocationsFallbackFn
}): Promise<Iso3166Location[]> {
  if (unlocalizedLocations.length === 0) {
    return unlocalizedLocations
  }
  const locations =
    getLocationsFromIntl({ unlocalizedLocations, language }) || (await fallbackFn({ unlocalizedLocations, language }))
  return locations
}
